import React, { useState, useEffect, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Button, FloatingLabel, Form } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import Factory from '../../components/factory';
import { get } from '../../services/apiController';
import PaginationInPage from '../Pagination';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import Item from '../../components/item';
import { GrDocumentExcel } from 'react-icons/gr';
import moment from 'moment';

const ItemUtilizationReport = () => {
  const [data, setData] = useState([]);
  const clickToDownload = useRef(null);
  const [state, setState] = useState({
    vendorId: '',
    factoryId: '',
    year: '',
  });
  // const [factories, setFactories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const getConsolidatedReport = (download = false) => {
    let url = `/inv/report/utilization-details/?factoryId=${state.factoryId}&download=${download}&year=${state.year}`;
    if (!download) {
      url += `&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
    }
    get(url)
      .then((res) => {
        if (download) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setData(res?.data?.data);
          setTotalRecords(res?.data.count);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data.data.message || err?.message);
      });
  };

  // function getFactories() {
  //   try {
  //     get(`/branches/?type=factory`).then((response) => {
  //       setFactories(response?.data?.rows);
  //     });
  //   } catch (err) {
  //     toast.error(err?.response?.data?.data?.message || err?.message);
  //   }
  // }

  useEffect(() => {
    if (state.year !== '') {
      getConsolidatedReport();
    }
  }, [currentPage]);

  // useEffect(() => {
  //   getFactories();
  // }, []);

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-3">
            <div className="d-flex" style={{ height: '100%', alignItems: 'center' }}>
              <h4 className="card-title" style={{ fontSize: '16px' }}>
                Item Utilization Consolidated Report | {totalRecords ?? 0}
              </h4>
            </div>
            <div className="d-flex mt-3" style={{ height: '100%', alignItems: 'center' }}>
              <h5 className="card-title" style={{ fontSize: '14px' }}>
                Note: This report is generated once in a day
              </h5>
            </div>
          </div>

          <div className="card-header-actions col-9 d-flex justify-content-end">
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="Select Year">
                <Form.Select
                  className="input"
                  value={state.year}
                  onChange={(e) => setState({ ...state, year: e.target.value })}
                  style={{ width: '170px' }}
                >
                  <option value="">Select Year</option>
                  {[2023, 2024, 2025].map((item) => {
                    return (
                      <option key={item} value={item}>
                        {`${item}-${item + 1}`}
                      </option>
                    );
                  })}
                </Form.Select>
              </FloatingLabel>
            </div>
            <div className="d-flex" style={{ maxWidth: '200px', flexDirection: 'column', alignItems: 'center' }}>
              <Button onClick={() => getConsolidatedReport()} type="submit" className="btn app-btn-default dark-color">
                Apply
              </Button>
              <GrDocumentExcel
                title="Download rejected items report"
                className="react-icons green mt-2"
                style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                onClick={() => getConsolidatedReport(true)}
              />
              <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
                HiddenClick
              </a>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr className="text-center">
                    {/* <th>Date</th> */}
                    <th rowSpan="2">Item</th>
                    <th rowSpan="2">Unit</th>
                    {/* <th>Factory</th> */}
                    <th colSpan="3">GRN</th>
                    <th colSpan="3">Production Indent</th>
                    <th rowSpan="2">Current Stock</th>
                    <th rowSpan="2">Total Value</th>
                    <th rowSpan="2">Total Value With GST</th>
                  </tr>
                  <tr className="text-center">
                    <th style={{ textAlign: 'center' }}>Quantity Issued</th>
                    <th style={{ textAlign: 'center' }}>Value</th>
                    <th style={{ textAlign: 'center' }}>Value With GST</th>
                    <th style={{ textAlign: 'center' }}>Quantity Received</th>
                    <th style={{ textAlign: 'center' }}>Value</th>
                    <th style={{ textAlign: 'center' }}>Value With GST</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    return (
                      <tr key={item.id}>
                        {/* <td>{moment(item.grnDate).format('DD/MM/YYYY')}</td> */}
                        <td>{item.itemName}</td>
                        <td>{item.unit}</td>
                        {/* <td>{item.branchName}</td> */}
                        <td>{item.inQty}</td>
                        <td>{item.inAmount}</td>
                        <td>{item.inAmountWithGst}</td>
                        <td>{item.outQty}</td>
                        <td>{item.outAmount}</td>
                        <td>{item.outAmountWithGst}</td>
                        <td>{item.netQty}</td>
                        <td>{item.totalAmount}</td>
                        <td>{item.totalAmountWithGst}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemUtilizationReport;
